import * as fragments from './fragments';

export const cartGet = `
query cart($id: ID!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  cart(id: $id) {
    ${fragments.cart}
  }
}
`;

export const cartCreate = `
mutation cartCreate($input: CartInput!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  cartCreate(input: $input) {
    cart {
      id
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartBuyerIdentityUpdate = `
mutation cartCreate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesAdd = `
mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesRemove = `
mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesUpdate = `
mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const bundleGet = (id) => `
query bundleGet($countryCode: CountryCode!) @inContext(country: $countryCode) {
  products(query: "tag:bundle_id::${id}", first: 9) {
    edges {
      node {
        ${fragments.productWithVariants}
      }
    }
  }
}
`;

export const getProductsByTag = `
query ProductsByTag($query: String!, $cursor: String, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  products(first: 250, query: $query, after: $cursor) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ${fragments.productWithVariants}
      }
    }
  }
}
`;

export const getProductsByIds = `
query getProductsByIds($ids: [ID!]!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  nodes(ids: $ids) {
    ...on Product {
      ${fragments.productWithVariants}
    }
  }
}
`;

export const collectionGet = `
query collectionGet($id: ID!, $first: Int!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  collection(id: $id) {
    products(first: $first) {
      pageInfo {
        hasNextPage
        endCursor
      },
      edges {
        node {
          ${fragments.productWithVariants}
        }
      }
    }
  }
}`;

export const getmetaobjectsUrgent = (id) => `
query {
  metaobject(id: "${id}") {
    id,
    handle,
    fields {
      key,
      value
    }
  }
}`;

export const gwpGet = (tag) => `
query gwpGet($countryCode: CountryCode!) @inContext(country: $countryCode) {
  products(query: "tag:${tag}", first: 20) {
    edges {
      node {
        ${fragments.productWithVariants}
      }
    }
  }
}`;

export const cartAttributesUpdate = `
mutation cartAttributesUpdate($cartId: ID!, $attributes: [AttributeInput!]!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const variantsById = `
query variantsById($ids: [ID!]!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  nodes(ids: $ids) {
    ... on ProductVariant {
      quantityAvailable
      id
      sku
      selectedOptions {
        name
        value
      }
      image {
        altText
        url
        width
        height
      }
      price {
        amount
        currencyCode
      }
      compareAtPrice {
        amount
        currencyCode
      }
      availableForSale
      product {
        ... on Product {
          id
          title
          handle
          tags
        }
      }
    }
  }
}
`;

export const getPromotions = `
query getPromotions {
  metaobjects(type: "a", first: 100) {
    edges {
      node {
        handle
        fields{
          key
          value
        }
      }
    }
  }
}`;
